
// <A extends Function>(f: A, interval?: number, immediate?: boolean): A & { clear(): void; }
export function debounce(func: (...args) => void, delay: number): (...args) => void {
  let inDebounce
  // need to use function instead of () =>, so we have the proper context of "this"
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function main(this: any, ...args) {
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(this, args), delay)
    return inDebounce
  }
}
